import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { savePresetsFailed, savePresetsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* savePresets(action) {
  try {
    const { id, data } = action.payload;
    const url = `${BACKEND_URL}/api/v1/violation-preset/${id}`;
    const dataResponse = yield makeRequest(url, data, action, 'PUT', true);
    if (dataResponse.status === OK) {
      yield put(savePresetsSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(savePresetsFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(savePresetsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
